import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from 'react-toolbox/lib/input';
import { Button } from 'react-toolbox/lib/button';
import { validate } from '../components/pages/RegistrationPage';
import formStyles from './Form.scss';

const propTypes = {
  error: PropTypes.string,
  email: PropTypes.string,
  onSubmit: PropTypes.func,
};

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    const { email = '' } = props;
    this.state = {
      firstname: '',
      lastname: '',
      username: email,
      companyName: '',
      password: '',
    };
  }

  componentDidUpdate(oldProps) {
    const { email } = oldProps;
    const { email: newEmail } = this.props;
    if (email !== newEmail) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ username: newEmail });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state, e);
  }

  handleInputChange(value, e) {
    const result = validate({ [e.target.name]: e.target.value });
    this.setState({
      [e.target.name]: e.target.value,
      error: result[e.target.name],
    });
  }

  render() {
    const { error, email } = this.props;
    const stateError = this.state.error;
    return (
      <form
        id="registration-form"
        name="registration-form"
        className={formStyles.form}
        action="/check"
        method="post"
        onSubmit={this.handleSubmit}
      >
        <Input
          className={formStyles.input}
          id="username"
          name="username"
          placeholder="E-mail"
          autoComplete="off"
          value={email}
          onChange={this.handleInputChange}
          readOnly
        />
        <Input
          className={formStyles.input}
          id="firstname"
          name="firstname"
          placeholder="First name"
          autoComplete="off"
          value={this.state.firstname}
          onChange={this.handleInputChange}
        />
        <Input
          className={formStyles.input}
          id="lastname"
          name="lastname"
          placeholder="Last Name"
          autoComplete="off"
          value={this.state.lastname}
          onChange={this.handleInputChange}
        />
        <div>
          <Input
            className={formStyles.input}
            id="password"
            type="password"
            name="password"
            placeholder="Password"
            autoComplete="off"
            onChange={this.handleInputChange}
          />
          <Input
            className={formStyles.input}
            id="password-confirm"
            placeholder="Confirm Password"
            type="password"
            name="passwordConfirm"
            onChange={this.handleInputChange}
          />
        </div>
        <Input
          className={formStyles.input}
          id="companyName"
          name="companyName"
          placeholder="Company"
          autoComplete="off"
          value={this.state.companyName}
          onChange={this.handleInputChange}
        />
        {(error || stateError) && (
          <p
            className={`text--left ${formStyles.error}`}
            style={{ 'white-space': 'pre-wrap' }}
          >
            {stateError || error}
          </p>
        )}
        <div className={formStyles.footer}>
          <Button
            accent
            raised
            type="submit"
            className={formStyles.footerSubmit}
            form="registration-form"
          >
            Submit
          </Button>
        </div>
      </form>
    );
  }
}
RegistrationForm.propTypes = propTypes;
export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/client/src/components/RegistrationForm.js